export enum DashboardMessageId {
  Update = 'update',
  Profile = 'profile',
  RedCard = 'red-card',
  Location = 'location'
}

export type DashboardMessageAction = 'close' | 'chevron' | 'none';

export interface DashboardMessageQueryResult {
  readonly id: DashboardMessageId;
  readonly priority: number;
  readonly title: string;
  readonly subtitle: string;
  readonly hasIcon: boolean;
  readonly clickable: boolean;
  readonly action: DashboardMessageAction;
  readonly dismissToken?: string;
}
